<template>
  <div>
    <v-row>
      <v-col :cols="12">
        <v-select
          label="Select Doc Type"
          :items="docTypes"
          @change="getSelectedDocType"
          v-model="selectedDocType"
        ></v-select>
        <v-select
          label="Select Template"
          :items="headerTemplates"
          @change="getSelectedTemplate"
          v-model="selectedHeaderTemplate"
        ></v-select>

        <UploadLogo @logo-loaded="getLogoBase64Url"></UploadLogo>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import UploadLogo from "./UploadLogo.vue";
export default {
  components: { UploadLogo },
  data: () => ({
    headerTemplates: [
      { text: "Colored Header", value: "colored" },
      { text: "Plain Header", value: "plain" },
    ],
    selectedHeaderTemplate: "colored",
    docTypes: ["Invoice", "Quotation", "Receipt"],
    selectedDocType: "Invoice",
  }),
  methods: {
    getSelectedTemplate() {
      this.$emit("template-selected", this.selectedHeaderTemplate);
    },
    getSelectedDocType() {
      this.$emit("docType-selected", this.selectedDocType);
    },
    getLogoBase64Url(logoBase64Url) {
      this.$emit("logo-loaded", logoBase64Url);
    },
  },
};
</script>
